import { render, staticRenderFns } from "./MyTask.vue?vue&type=template&id=b2a46af8&scoped=true&"
import script from "./MyTask.vue?vue&type=script&lang=js&"
export * from "./MyTask.vue?vue&type=script&lang=js&"
import style0 from "./MyTask.vue?vue&type=style&index=0&id=b2a46af8&prod&lang=scss&scoped=true&"
import style1 from "./MyTask.vue?vue&type=style&index=1&id=b2a46af8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a46af8",
  null
  
)

export default component.exports